import { render, staticRenderFns } from "./InquiryDetailEng.vue?vue&type=template&id=e181fe8a&scoped=true"
import script from "./InquiryDetailEng.vue?vue&type=script&lang=ts"
export * from "./InquiryDetailEng.vue?vue&type=script&lang=ts"
import style0 from "./InquiryDetailEng.vue?vue&type=style&index=0&id=e181fe8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e181fe8a",
  null
  
)

export default component.exports